import {
  MDBAlert,
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getMisc, updateFaxGroup } from "../apiclients/streamsapi_bridge";
import TopMessage from "../components/header/TopMessage";
import TopSuccess from "../components/header/TopSuccess";
import AddUsersToFaxGroup from "./popups/misc/AddUsersToFaxGroup";
import RemoveToUser from "./popups/misc/RemoveToUser";
import PopupLoader from "./popups/PopupLoader";
import PopupLoaderNew from "./popups/PopupLoaderNew";
import { customSearch, useAutoFocusSearchAfterLoads } from "../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../apiclients/UIConstant";

function FaxGroupUsers({ users, code,isActive }) {
  const [basicModal, setBasicModal] = useState(false);
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");
  const [internalError, setInternalError] = useState(false);
  const [addUser, setAddUser] = useState(false);
  const toggleOpen = () => setAddUser(!addUser);
  const [userList, setuserList] = useState([]);
  const [sourceUsers, setSourceUsers] = useState([]);
  const [updateUsers, setUpdateUsers] = useState([]);
  const [isAddedUsers, setIsAddedUsers] = useState(false);
  const [isdelete, setIsDelete] = useState(false);
  const dUtogglePopup = () => setIsDelete(!isdelete);
  const [isdeleteUser, setIsDeleteUser] = useState(false);
  const addUserToFaxGrpRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
  function handleClick() {
    addUserToFaxGrpRef.current.click();
  }
  useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)
  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  // const toggleOpen = () => setBasicModal(!basicModal);
  useEffect(() => {
    if (users?.length > 0) {
      setuserList(users);
    }
  }, [users]);

  useEffect(()=>{
  let processdrows = [];
  userList.map((user) => {
    processdrows.push({
      usersInfo: user,
      name: user?.name + " " ?? "",
      email: user.email ? user.email + "" : "",
      agentid: user.agentid ? user.agentid + "" : "",
      extension: user.extensions ? user.extensions : "--",
      privilege:
        user.privilege === 1
          ? "Send"
          : user.privilege === 2
          ? "Receive"
          : user.privilege === 3
          ? "Send & Receive"
          : " ",
      delete: (
        <>
          <div className="ms-4 w-40">
            <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
              <MDBIcon
                icon="times"
                color="primary"
                onClick={(e) => handleDelete(e, user)}
              />
            </div>
          </div>
        </>
      ),
    });
  });
  setFilteredRows(processdrows);
  setUserDetails(processdrows)
  setDataLoaded(true)
  },[userList,isActive])

  useEffect(() => {
    async function fetchData() {
      let UserList = [],
        apiResponse = {};
      apiResponse = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["faxgrp_users"], groupcode: code }
      );

      if (apiResponse.status === 200) {
        UserList = await apiResponse.json();
        console.log(
          "Fax Group UserList 11111::::: " + JSON.stringify(UserList)
        );

        UserList = UserList?.misc?.faxgrp_users ?? [];
        // alert(JSON.stringify(UserList));
        setSourceUsers(UserList);
      } else {
      }
    }

    if (code && code != "") {
      fetchData();
    }
  }, [code]);

  const actionData = {
    columns: [
      { label: "User Name", field: "name", sort: true },
      { label: "Email", field: "email" },
      { label: "Extension", field: "extension" },
      { label: "Privileges", field: "privilege" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: userDetails,
  };

   const handleManualSearch = (searchValue) =>{
    setSearchValue(searchValue); 
    const filtered = customSearch(userDetails, searchValue, UIConstant.FAX_GROUP_USERS);
  
    setFilteredRows(filtered);
  };

  const handleDelete = (event, infoObj) => {
    event.preventDefault();
    event.stopPropagation();
    dUtogglePopup();
    console.log(
      "infoObj :::::::::::::::::::::::::::: " + JSON.stringify(infoObj)
    );
    setUpdateUsers([infoObj]);
  };

  useEffect(() => {
    if (updateUsers.length > 0 && isAddedUsers) {
      console.log("UpadateUsers ::::" + JSON.stringify(updateUsers));
      updateTheUser("addedUsers");
      setIsAddedUsers(false);
    }
  }, [updateUsers, isAddedUsers]);

  useEffect(() => {
    if (updateUsers.length > 0 && isdeleteUser) {
      updateTheUser("removedUsers");
      setIsDeleteUser(false);
    }
  }, [updateUsers, isdeleteUser]);

  async function updateTheUser(fieldName) {
    setInternalError(false);
    const agentids = updateUsers.map((item) => ({
      user: item.agentid,
      privilege: parseInt(item.privilege),
    }));
    let update = {};

    let saverep;
    setIsloading(true);

    update = {
      reqid: 117,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      code: code,
      [fieldName]: Array.from(agentids),
    };
    console.log("Fax Add Remove Users Request ::: " + JSON.stringify(update));
    saverep = await updateFaxGroup(update);

    console.log(saverep);
    let saverepeMsg = await saverep.json();
    setIsloading(false);
    const usernames = new Set(updateUsers.map((item) => item.name));
    const users = Array.from(usernames).join(", ");
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "addedUsers") {
        const updatedLists = sourceUsers.filter(
          (user) =>
            !updateUsers.find((addedUser) => addedUser.agentid === user.agentid)
        );
        setSourceUsers(updatedLists);
        const updatedUsers = [...userList, ...updateUsers];
        console.log("Updatedlist" + JSON.stringify(updateUsers));
        setuserList((prev) => [
          ...prev,
          ...updateUsers.map(({ extension, ...rest }) => ({
            ...rest,
            extensions: extension,
          })),
        ]);
        setSuccessMessage(`Fax Group User(s) ${users} added successfully.`);
      } else {
        console.log("updatedUsers :::::::::::: " + JSON.stringify(updateUsers));
        const filterExtension = new Set(
          updateUsers.map((item) => item.extensions)
        );
        console.log("filterExtension ::::::::::: " + filterExtension.size);
        const filterUsers = userList.filter(
          (item) => !filterExtension.has(item.extensions)
        );
        setuserList(filterUsers);
        setSourceUsers((prev) => [
          ...prev,
          ...updateUsers.map((user) => ({
            ...user,
            extension: user.extensions,
          })),
        ]);
        setSuccessMessage(`Fax Group User(s) ${users} removed successfully.`);
      }
    } else {
      if (fieldName === "removedUsers") {
        const filterExtension = new Set(
          updateUsers.map((item) => item.extensions)
        );
        let modifyUser = userList.filter(
          (item) => !filterExtension.has(item.extensions)
        );
        modifyUser = [...modifyUser, ...updateUsers];
        setuserList(modifyUser);

        setInternalError(true);
      } else {
        if (saverepeMsg?.message?.errors && saverepeMsg?.message?.errors[0]);
        setInternalError(true);
        seterrorMessage(saverepeMsg?.message?.errors[0]?.message);
      }
    }
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div className="general-settings m-0 ms-3">Users</div>
      </div>
      <div className="faxgroupsdetails-datatable">
        <div className="actionbar">
          <MDBBtn onClick={(e) => toggleOpen()}>
            <MDBIcon fas icon="plus" color="light" className="me-2" /> Add User
          </MDBBtn>
        </div>
          <div className='mb-2 mt-0 position-relative w-auto'>
                        <MDBInput
                          label="Search"
                          value={searchValue}
                          ref={searchRef}
                          onChange={(e) => handleManualSearch(e.target.value)}
                        />
                        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                      </div>
        <MDBDatatable
        key={searchValue}
          // search
          className="actioncolumn"
          hover
          sortField="User Name"
          // pagination={false}
          data={{...actionData,rows:filteredRows}}
          onRowClick={toggleOpen}
          entries={50}
        />
      </div>

      {addUser && (
        <PopupLoaderNew
          title="Add User"
          size="lg"
          content={
            <>
              <AddUsersToFaxGroup
                selectedUsers={userList}
                sourceUsers={sourceUsers}
                setUpdateUsers={setUpdateUsers}
                setIsAddedUsers={setIsAddedUsers}
                onClose={toggleOpen}
                ref={addUserToFaxGrpRef}
                setIsloading={setisLoading}
              />
            </>
          }
          onShow={setAddUser}
          onClose={toggleOpen}
          onSave={handleClick}
          isloading={isLoading}
          flag={2}
        />
      )}
      {isdelete && (
        <PopupLoaderNew
          title={"Remove User"}
          content={
            <RemoveToUser
              setIsDeleteUser={setIsDeleteUser}
              onClose={dUtogglePopup}
              ref={addUserToFaxGrpRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setIsDelete}
          onClose={dUtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}
      {internalError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setInternalError(false)}
        >
          {errorMessage ?? "Internal Server Error"}
        </MDBAlert>
      )}
      {successMessage && (
        <>
          <TopSuccess>
            <TopMessage successMessage={successMessage} />
          </TopSuccess>
        </>
      )}
      <Tooltip
        anchorSelect=".deleteToolTip"
        place="top"
        className="exampleTooltip"
      >
        Remove
      </Tooltip>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
}

export default FaxGroupUsers;
